<div class="header">
	<h6>Internal documents</h6>
</div>

<div class="documents">

	<div class="document">
		<div>
			<div class="document-name">Application Review checklist</div>
			<div class="created">created on {{applicationReviewerChecklistCreationDate | localizedDate | async}}</div>
		</div>
		<nb-icon class="document-link" icon="external-link-outline" (click)="openChecklistDocument(applicationReviewerChecklist, APPLICATION_REVIEW_CHECKLIST_TYPE)"></nb-icon>

	</div>

</div>
